import React from 'react';

import { Panel, PanelProps } from 'baseui/accordion';

export const CustomPanel: React.FC<PanelProps> = props => (
    <Panel
        {...props}
        onKeyDown={event => {
            const selfItem = event.target as HTMLDivElement | null;
            if (!selfItem) {
                return;
            }
            const selfLi = selfItem.closest('li');

            if (!selfLi) {
                return;
            }

            let elementToFocus: HTMLButtonElement | null = null;

            if (event.key === 'ArrowDown') {
                elementToFocus = selfLi.nextSibling?.firstChild as HTMLButtonElement;
            }
            if (event.key === 'ArrowUp') {
                elementToFocus = selfLi.previousSibling?.firstChild as HTMLButtonElement;
            }

            if (event.key === 'Home') {
                elementToFocus = selfLi.parentElement?.firstChild?.firstChild as HTMLButtonElement;
            }

            if (event.key === 'End') {
                elementToFocus = selfLi.parentElement?.lastChild?.firstChild as HTMLButtonElement;
            }

            if (elementToFocus) {
                elementToFocus.focus();
                event.preventDefault();
            }
        }}
    />
);